import React, { useState, useEffect } from "react";
import "./TopBar.css";

export default function TopBar({ onInfoClick, onContactClick, onLogoClick }) {
  const [time, setTime] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const updateClock = () => {
      const d = new Date();
      setTime(d.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit', second:'2-digit'}));
    };
    updateClock();
    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleMenuItemClick = (action) => {
    setMenuOpen(false);
    action();
  };

  return (
    <>
      <div className="top-bar">
        <div className="top-left">
          <button className="hamburger-menu" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
          <img 
            src="apple.png" 
            alt="Apple" 
            className="apple-logo" 
            onClick={onLogoClick}
          />
          <span className="karel-name" onClick={onLogoClick}>Karel</span>
          <span onClick={onInfoClick}>Information</span>
          <span onClick={onContactClick}>Contact</span>
        </div>
        <div className="top-right">
          <div className="social-icons">
            <a href="https://wa.me/33783713566" target="_blank" rel="noopener noreferrer">
              <img src="/whatsapp.png" alt="WhatsApp" className="social-icon" />
            </a>
            <a href="https://www.instagram.com/karelbhc" target="_blank" rel="noopener noreferrer">
              <img src="/insta.png" alt="Instagram" className="social-icon" />
            </a>
          </div>
          {time}
        </div>
      </div>

      {menuOpen && (
        <>
          <div className="menu-overlay" onClick={() => setMenuOpen(false)} />
          <div className="hamburger-menu-content">
            <button className="menu-item" onClick={() => handleMenuItemClick(onInfoClick)}>
              Information
            </button>
            <button className="menu-item" onClick={() => handleMenuItemClick(onContactClick)}>
              Contact
            </button>
            <div className="menu-divider" />
            <a 
              href="https://wa.me/33783713566" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="menu-item menu-link"
              onClick={() => setMenuOpen(false)}
            >
              <img src="/whatsapp.png" alt="WhatsApp" />
              WhatsApp
            </a>
            <a 
              href="https://www.instagram.com/karelbhc" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="menu-item menu-link"
              onClick={() => setMenuOpen(false)}
            >
              <img src="/insta.png" alt="Instagram" />
              Instagram
            </a>
          </div>
        </>
      )}
    </>
  );
}
